let whitespaceRE = /\s+/;
let arrProto = Array.prototype;

// dom utility functions
let dom = {

  /**
   * Add a class to the supplied element (accepts multiple names)
   * @param {Element} el   – DOM element
   * @param {String}  name – class name
   */

  addClass( el, name ) {
    let classes = el.className.split( whitespaceRE );
    let names;

    // don't pay for an array alloc unless we need to
    if ( arguments.length > 2 ) {
      names = arrProto.slice.call( arguments, 1 );
      arrProto.push.apply( classes, names );
    } else {
      classes.push( name );
    }

    el.className = classes.join(' ');
    return el;
  },

  /**
   * Remove a class from the supplied element (accepts multiple names)
   * @param {Element} el   – DOM element
   * @param {String}  name – class name
   */

  removeClass( el, name ) {
    let classes = el.className.split( whitespaceRE );
    let names;

    // don't pay for an array alloc unless we need to
    if ( arguments.length > 2 ) {
      names = arrProto.slice.call( arguments, 1 );
    }

    classes = classes.filter( function( c ) {
      return names ? names.indexOf( c ) === -1 : c !== name;
    });

    el.className = classes.join(' ');
    return el;
  },

  /**
   * Toggle a class from the supplied element (accepts multiple names)
   * @param {Element} el   – DOM element
   * @param {String}  name – class name
   */

  toggleClass( el ) {
    let classes = el.className.split( whitespaceRE );
    let names = arrProto.slice.call( arguments, 1 );

    names.forEach( function( name ) {
      let index = classes.indexOf( name );
      if ( index === -1 ) {
        classes.push( name );
      } else {
        classes.splice( index, 1 );
      }
    });

    el.className = classes.join(' ');
    return el;
  },

  /**
   * Make an ajax resuest
   *
   * @param  {Object}   opts     – options object (url is required)
   * @param  {Object}   data     – optional payload
   * @param  {Function} callback – error-first callback
   * @return {Object}            – XMLHttpRequest
   */

  ajax( opts, data, callback ) {
    let xhr;
    let key;

    if ( arguments.length < 3 ) {
      callback = data;
      data = undefined;
    }

    opts.method = opts.method || 'GET';
    opts.headers = opts.headers || { 'Content-Type': 'application/json' };

    xhr = new XMLHttpRequest();
    xhr.open( opts.method, opts.url, true );

    for ( key in opts.headers ) {
      xhr.setRequestHeader( key, opts.headers[ key ] );
    }

    if ( opts.withCredentials === true ) {
      xhr.withCredentials = true;
    }

    xhr.onreadystatechange = function() {
      let res;
      let type;

      if ( xhr.readyState === 4 ) {
        if ( xhr.status >= 200 && xhr.status < 300 ) {
          type = xhr.getResponseHeader('Content-Type');
          res = xhr.responseText;

          if ( /json/.test( type ) ) {
            try {
              res = JSON.parse( res );
            } catch ( ex ) {
              return callback( ex );
            }
          }

          callback( null, res );
        } else {
          const err = new Error( `Failed with status code ${ xhr.status }` );
          err.xhr = xhr;

          callback( err );
        }
      }
    };

    // old IE freaks out if you try to write `undefined`
    if ( typeof data === 'undefined' ) {
      xhr.send();
    // try to stringify if we got an object, otherwise just coerce to string
    } else {
      try {
        data = JSON.stringify( data );
      } catch ( ex ) {}
      xhr.send( String( data ) );
    }

    return xhr;
  }

};

export default dom;
